<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleArea.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleArea.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex ts-items-center ts-space-x-3">
            <ts-input
              v-tooltip="$t('saleArea.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table 
					:columns="columns" 
					:records="resources" 
					:loading="loading"
					:expandable="true"
				>
          <template v-slot="{ record }">
            <td>{{ record.sale_name }}</td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.description }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
					<div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto">
              <thead>
                <tr>
                    <th>{{ $t('saleArea.province') }}</th>
                    <th>{{ $t('saleArea.district') }}</th>
                    <th>{{ $t('saleArea.commune') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in prop.record.area_communes"
                  :key="index"
                >
                  <td>{{ item.pro_name_en }}</td>
                  <td>{{ item.dis_name_en }}</td>
                  <td>{{ item.comm_name_en }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>

			<!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('saleArea.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="50%"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>

    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FromAction from './form.vue'

export default {
  name: 'saleArea',
	components: {
		FromAction,
	},
  data() {
    return {
      loading: false,
			showForm: false
    }
  },
  computed: {
    ...mapState('sale/saleArea', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.sale.saleArea.search
      },
      set(newValue) {
        this.$store.commit('sale/saleArea/SET_SEARCH', newValue)
        this.$store.commit('sale/saleArea/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('saleArea.sale'), style: 'width: 20%' },
        {
          name: this.$t('saleArea.description'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:80px' }
      ]
    }
  },
  methods: {
		addNew() {
      this.showForm = true
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('sale/saleArea/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('sale/saleArea/destroy', record.sa_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    edit(record) {
      this.$store.commit('sale/saleArea/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
      this.$store.commit('sale/saleArea/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
		},
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('sale/saleArea/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
